const ZONES = Intl.supportedValuesOf ? Intl.supportedValuesOf("timeZone") : ["UTC"];
const ALL = ZONES.includes("UTC") ? ZONES : ["UTC", ...ZONES];

export const TimezoneSelect = ({ value, onChange, testId }) => (
  <select className="hud-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
    {(ALL.includes(value) ? ALL : [value, ...ALL]).map((z) => <option key={z} value={z}>{z.replace(/_/g, " ")}</option>)}
  </select>
);

export const browserTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
